import script from "./creditor-index.vue?vue&type=script&setup=true&lang=js"
export * from "./creditor-index.vue?vue&type=script&setup=true&lang=js"

import "./creditor-index.vue?vue&type=style&index=0&id=5d807218&lang=css"

const __exports__ = script;

export default __exports__